export default __webpack_public_path__ + "static/media/element_68.3b87f9b9.webp";